import styled from 'styled-components';

import { visuallyHiddenCss } from 'components/VisuallyHidden';
import { colors, h2Text, h3Text, namedBreakpoints, shadows } from 'theme';

export const TileGridBlockTileModalBackdrop = styled.div`
  position: fixed;
  z-index: 99998;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(54, 54, 54, 0.6);
`;

export const TileGridBlockTileModalContainer = styled.div`
  position: fixed;
  z-index: 99999;
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;

  @media (min-width: ${namedBreakpoints.mdUp}) {
    width: calc(100% - 140px);
    max-width: 1573px;
    height: 791px;
    max-height: calc(100% - 140px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    overflow: hidden;
    border-radius: 8px;

    &:before {
      content: '';
      position: absolute;

      top: 0;
      left: 0;
      width: 100%;
      height: 15px;
      background: ${colors.waterBlue};
    }
  }

  @media (max-width: ${namedBreakpoints.mdDown}) {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 729px;
    height: 100%;
    align-items: center;
  }
`;

export const TileGridBlockTileModalActionsContainer = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: ${namedBreakpoints.mdUp}) {
    margin-top: 34px;
    justify-content: flex-end;
  }

  @media (max-width: ${namedBreakpoints.mdDown}) {
    width: 100%;
    height: 72px;
    flex-shrink: 0;
    background: white;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    padding-left: 45px;

    justify-content: space-between;
  }

  @media (max-width: ${namedBreakpoints.xsDown}) {
    padding-left: 31px;
  }
`;

export const TileGridBlockTileModalArrowsContainer = styled.div`
  @media (min-width: ${namedBreakpoints.mdUp}) {
    position: absolute;
    top: 50%;
    width: 100%;
    padding-left: 43px;
    padding-right: 43px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
    pointer-events: none;
  }

  @media (max-width: ${namedBreakpoints.mdDown}) {
    display: flex;
    align-items: center;

    > *:not(:first-of-type) {
      margin-left: 49px;
    }
  }

  @media (max-width: ${namedBreakpoints.xsDown}) {
    > *:not(:first-of-type) {
      margin-left: 44px;
    }
  }
`;

export const TileGridBlockTileModalArrow = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.waterBlue};
  border-radius: 100%;
  transition: 0.3s all ease;

  &:not(:disabled) {
    pointer-events: all;
  }

  &:disabled {
    opacity: 0.5;
  }

  &:hover {
    box-shadow: ${shadows.low};
  }
`;

export const TileGridBlockTileModalCloseButton = styled.button`
  height: 41px;
  margin-right: 39px;
  color: ${colors.battleshipGrey};
  background-color: transparent;
  border-radius: 0;
  display: flex;
  align-items: center;

  &:hover:not(:disabled) {
    color: ${colors.waterBlue};
  }
`;

export const TileGridBlockTileModalCloseButtonText = styled.span`
  height: 18px;
  margin-right: 8px;
  display: block;

  @media (max-width: ${namedBreakpoints.xsDown}) {
    ${visuallyHiddenCss}
  }
`;

export const TileGridBlockTileContent = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  flex: 1;

  @media (min-width: ${namedBreakpoints.mdUp}) {
    margin-top: 20px;
    margin-bottom: 58px;
    overflow: hidden;
  }

  @media (max-width: ${namedBreakpoints.mdDown}) {
    --tile-grid-block-mobile-max-width: 559px;

    flex-direction: column;
    padding-top: 48px;
    overflow: auto;
    width: 100%;
    padding-left: 32px;
    padding-right: 32px;
    align-items: center;

    > *:not(:first-of-type) {
      margin-top: 37px;
    }
  }

  @media (max-width: ${namedBreakpoints.xsDown}) {
    padding-top: 31px;
  }
`;

export const TileGridBlockTileContentLeft = styled.div`
  flex: 1;
  flex-shrink: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: ${namedBreakpoints.mdDown}) {
    max-width: var(--tile-grid-block-mobile-max-width);
  }
`;

export const TileGridBlockTileContentImageContainer = styled.div`
  flex: 1;
  height: 100%;

  @media (min-width: ${namedBreakpoints.mdUp}) {
    padding-left: 108px;
  }
`;

export const TileGridBlockTileContentRight = styled.div`
  flex: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${namedBreakpoints.mdUp}) {
    overflow: hidden;
    max-height: 100%;
  }

  @media (max-width: ${namedBreakpoints.mdDown}) {
    max-width: var(--tile-grid-block-mobile-max-width);
  }
`;

export const TileGridBlockTileText = styled.div`
  @media (min-width: ${namedBreakpoints.mdUp}) {
    width: 551px;
    max-width: calc(100% - 36px);
    padding-left: 32px;
    padding-right: 74px;
    overflow: auto;
    max-height: 1121px;
  }
`;

export const TileGridBlockTileHeading = styled.h2`
  margin: 0;

  ${h2Text}
`;

export const TileGridBlockTileSubheading = styled.h3`
  margin-top: 27px;
  margin-bottom: 16px;

  ${h3Text}
`;
